<template>
	<div class="card card-order-ufund custom-card mt-4 mb-0">
		<div class="card-header typo-h5 d-flex align-items-center">
			<span>UFund info</span>
		</div>
		<div class="card-body">
			<CRow>
				<!-- ข้อมูลนักศึกษาที่ได้จากการ validate กับ UFund ตอน checkout -->
				<CCol>
					<h3 class="typo-h6">
						Student info
					</h3>
					<div>
						<label class="ufund-info-label mb-0" data-test-id="ufund-application-no">
							Application no.:
							<span class="ufund-info-value">{{ ufundInfo.applicationNo | nullableToDashFormat }}</span>
						</label>
						<label class="ufund-info-label mb-0" data-test-id="ufund-customer-name">
							Customer name:
							<span class="ufund-info-value">{{ ufundInfo.customerName | nullableToDashFormat }}</span>
						</label>
						<label class="ufund-info-label mb-0" data-test-id="ufund-phone">
							Phone:
							<span class="ufund-info-value">{{ ufundInfo.phone | nullableToDashFormat }}</span>
						</label>
						<label class="ufund-info-label mb-0" data-test-id="ufund-application-number">
							Application number (UFund):
							<span class="ufund-info-value">{{ ufundInfo.applicationNumber | nullableToDashFormat }}</span>
						</label>
						<label class="ufund-info-label mb-0" data-test-id="ufund-app-id">
							App ID:
							<span class="ufund-info-value">{{ ufundInfo.appId | nullableToDashFormat }}</span>
						</label>
						<label class="ufund-info-label" data-test-id="ufund-uuid">
							UFund UUID:
							<span class="ufund-info-value">{{ ufundInfo.uuid | nullableToDashFormat }}</span>
						</label>
					</div>
				</CCol>

				<!-- ยอดเงินฝั่ง UFund - เป็นคนละชุดกับยอดของออเดอร์ จึงแยกบล็อกให้ชัด -->
				<CCol>
					<h3 class="typo-h6">
						Payment amount
					</h3>
					<div>
						<label class="ufund-info-label mb-0" data-test-id="ufund-prod-price">
							Product price (excl. VAT):
							<span class="ufund-info-value">{{ ufundInfo.prodPrice | nullableToDashFormat }}</span>
						</label>
						<label class="ufund-info-label mb-0" data-test-id="ufund-prod-vat">
							VAT:
							<span class="ufund-info-value">{{ ufundInfo.prodVat | nullableToDashFormat }}</span>
						</label>
						<label class="ufund-info-label mb-0" data-test-id="ufund-prod-sum-price">
							Total (incl. VAT):
							<span class="ufund-info-value">{{ ufundInfo.prodSumPrice | nullableToDashFormat }}</span>
						</label>
						<label class="ufund-info-label" data-test-id="ufund-down-pay-amt">
							Down payment:
							<span class="ufund-info-value">{{ ufundInfo.downPayAmt | nullableToDashFormat }}</span>
						</label>
					</div>
				</CCol>
			</CRow>
		</div>
	</div>
</template>

<script>
export default {
	name: 'OrderDetailUFundInfo',
	props: {
		ufundInfo: {
			type: Object,
			default: () => ({}),
		},
	},
};
</script>

<style lang="scss" scoped>
	.ufund-info {
		// .ufund-info-label
		&-label {
			@include typo-label;

			display: block;
			color: $color-black-45;
		}

		// .ufund-info-value
		&-value {
			@include typo-body-2;

			color: $color-black;
			font-weight: 400;
		}
	}
</style>
